<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div
        class="card-header align-items-center justify-content-between border-0"
      >
        <h5 class="card-title font-bold">گزارش بن و امتیازات</h5>
      </div>

      <div class="card-body">
        <b-form
          class="row align-items-end mb-6"
          @submit.prevent="loadUserPointsList"
        >
          <div class="col-md-3">
            <b-form-group>
              <label>انتخاب مشتری</label>
              <CustomerSearch
                v-model="form.selectedCustomer"
                :allow-empty="true"
                :show-label="false"
              />
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group>
              <label>نوع بن</label>
              <select v-model="form.type" class="form-control">
                <option
                  v-for="opt in typeOptions"
                  :key="opt.value"
                  :value="opt.value"
                >
                  {{ opt.text }}
                </option>
              </select>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group>
              <label>تاریخ شروع</label>
              <date-picker
                type="date"
                v-model="form.from_date"
                format="YYYY-MM-DD"
                display-format="jYYYY-jMM-jDD"
              />
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group>
              <label>تاریخ پایان</label>
              <date-picker
                type="date"
                v-model="form.to_date"
                format="YYYY-MM-DD"
                display-format="jYYYY-jMM-jDD"
              />
            </b-form-group>
          </div>
          <div class="col-md-3 mb-3">
            <button :disabled="disabled" class="btn btn-primary" type="submit">
              نمایش گزارشات
            </button>
            <button
              :disabled="disabled"
              class="btn btn-outline-secondary mr-2"
              type="button"
              @click="resetFilters"
            >
              حذف فیلترها
            </button>
          </div>
        </b-form>

        <!-- <div v-if="totals" class="row mb-3">
          <div class="col-md-4">
            <div class="alert alert-success mb-0">
              جمع امتیاز: <strong>{{ totals.score_value | price }}</strong>
            </div>
          </div>
          <div class="col-md-4">
            <div class="alert alert-success mb-0">
              جمع بن: <strong>{{ totals.bon_value | price }}</strong>
            </div>
          </div>
          <div class="col-md-4">
            <div class="alert alert-warning mb-0">
              جمع بن لغو شده:
              <strong>{{ totals.bon_canceled | price }}</strong>
            </div>
          </div>
        </div> -->

        <b-table
          :style="{ opacity: disabled ? '0.6' : 1 }"
          bordered
          responsive
          striped
          v-if="items && items.length"
          :fields="fields"
          :items="items"
        >
          <template v-slot:cell(order_type)="data">
            <span v-if="data.item.mini_order_id" class="badge badge-info">
              حضوری
            </span>
            <span v-else-if="data.item.order_id" class="badge badge-info">
              آنلاین
            </span>
            <span v-else>-</span>
          </template>
          <template v-slot:cell(score_value)="data">
            <span
              :class="{
                'badge-danger': data.item.score_value < 0,
                'badge-success': data.item.score_value > 0,
              }"
              class="font-bold badge"
              dir="ltr"
            >
              {{ data.item.score_value < 0 ? "-" : "" }}
              {{ data.item.score_value | price }}
            </span>
          </template>

          <template v-slot:cell(bon_value)="data">
            <span
              :class="{
                'badge-danger': data.item.bon_value < 0,
                'badge-success': data.item.bon_value > 0,
              }"
              class="font-bold badge"
              dir="ltr"
            >
              {{ data.item.bon_value < 0 ? "-" : "" }}
              {{ data.item.bon_value | price }}
            </span>
          </template>
          <template v-slot:cell(bon_canceled)="data">
            {{ data.item.bon_canceled | price }}
          </template>

          <template v-slot:cell(date)="data">
            {{ data.item.date | Date }}
          </template>
        </b-table>

        <div v-else class="alert alert-info">
          موردی یافت نشد
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import scoreBonImpl from "@@/core/pages/customerClub/clubReports/scoreBon/scoreBonImpl.js";
export default {
  extends: scoreBonImpl,
};
</script>
